
// Namespacing

window.site = (window.site || {});

// Side panel - opened / close

site.SidePanel = (function SidePanel($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false,
      sidePanelOverlay   = '.sidepanel-overlay',
      sidePanel          = '.sidepanel';

  /**
   * Initializes the class.
   * @public
   */
  var init = function() {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Initiate SidePanel
    initEvents();

    return true;

  };

    // ------------------------------------
    // INIT
    // ------------------------------------

    var initEvents = function() {

        $('[data-trigger-sidepanel]').on('click', function(event) {
            event.preventDefault();

            var panelValue = $(this).data('trigger-sidepanel');

            openPanel(panelValue);
        });

        $('body').on('click', '[data-close-sidepanel]', function(event) {
            event.preventDefault();

            closePanel();
        });

        $('body').on('click', sidePanelOverlay, function(event) {
            event.preventDefault();

            closePanel();
        });

    };

    var openPanel = function(panelValue) {

      $('.sidepanel-overlay.'+panelValue+'').addClass('opened');

      $('.sidepanel.'+panelValue+'').addClass('opened');

      $('body').css({
        "overflow": "hidden",
        "position": "absolute",
        "width": "100%",
      });

    };

    var closePanel = function() {

      $(sidePanelOverlay).removeClass('opened');
      $(sidePanel).removeClass('opened');

      $( 'body' ).attr('style','');

    };

    return {
      init: init,
      openPanel: openPanel,
      closePanel: closePanel
    };

}.bind(site, jQuery)());